import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import { ReactComponent as RecycleSvg } from './assets/recycle.svg';

const RecycleIcon = React.forwardRef((args, ref) => <SvgIcon component={RecycleSvg} ref={ref} {...args} />);

export default RecycleIcon;
